<div #lijst class="list wv-responsive-padding-left">
  <ng-content></ng-content>
</div>
<div *ngIf="canScroll" class="navigation wv-responsive-margin">
  <button class="wv-bold-button" (click)="scrollPrevious()"><fa-icon icon="chevron-left" size="xs"></fa-icon>Vorige
  </button>
  <button class="wv-bold-button" (click)="scrollNext()">Volgende<fa-icon icon="chevron-right" size="xs"></fa-icon>
  </button>
</div>
